import { userAccountSlice } from './userAccount.slice.ts';

export const { setUserAccount, resetUserAccount } = userAccountSlice.actions;
